import openDatabase from "../../IndexedDB/openDatabase";

const storeEnumsInIndexedDB = async (enumRes, dbName = "ERP_DB", storeName = "Enums", dbVersion = 1) => {
  try {
    // Open or create the database and object store
    const db = await openDatabase(dbName, storeName, dbVersion);

    // Ensure that the store is available
    if (!db.objectStoreNames.contains(storeName)) {
      throw new Error(`Object store '${storeName}' does not exist in the database`);
    }

    // Start a readwrite transaction
    const transaction = db.transaction(storeName, "readwrite");
    const store = transaction.objectStore(storeName);

    // Optimized iteration with error handling
    const transactionPromises = Object.entries(enumRes).map(
      ([key, value]) =>
        new Promise((resolve, reject) => {
          const request = store.put(value, key); // Store each key-value pair in the object store

          request.onsuccess = () => resolve();
          request.onerror = (error) => reject(error);
        })
    );

    // Wait for all the put operations to complete
    await Promise.all(transactionPromises);

    // console.log("Client data stored successfully");
  } catch (error) {
    console.error("Error storing client data:", error);
  }
};

export default storeEnumsInIndexedDB;
